window.$ = window.jQuery = require('jquery');

function marcadoErrores(jqXHR, $form) {
    if (jqXHR.status === 422) {
        $form.find(".msgerror").remove();
        $form.find(".field .msg-error").remove();
        $form.find(".field.is-danger").removeClass("is-danger");
        $.each(jqXHR.responseJSON.errors, function (campo, errores) {
            var $grupo = $form.find(".field:has(input[name='"+campo+"'], select[name='"+campo+"'], textarea[name='"+campo+"'])");
            $grupo.addClass("is-danger");
            var texto = '';
            $.each(errores, function (index, error) {
                texto += "<strong>" + error+"</strong><br>";
            });
            $grupo.append('<span class="help is-danger msg-error">'+texto+'</span>');
        });

        if (jqXHR.responseJSON && typeof jqXHR.responseJSON.msgerror === 'string') {
            $form.prepend( "<div class=\"msgerror notification is-danger\" role=\"alert\">"+jqXHR.responseJSON.msgerror+"</div>" );
        }
    }
}

module.exports = marcadoErrores;